export enum MONTHS_SHORT {
  'GENERAL.JANUARY_SHORT', // Jan
  'GENERAL.FEBRUARY_SHORT', // Feb
  'GENERAL.MARCH_SHORT', // Mar
  'GENERAL.APRIL_SHORT', // Apr
  'GENERAL.MAY_SHORT', // May
  'GENERAL.JUNE_SHORT', // Jun
  'GENERAL.JULY_SHORT', // Jul
  'GENERAL.AUGUST_SHORT', // Aug
  'GENERAL.SEPTEMBER_SHORT', // Sep
  'GENERAL.OCTOBER_SHORT', // Oct
  'GENERAL.NOVEMBER_SHORT', // Nov
  'GENERAL.DECEMBER_SHORT', // Dec
}

// changed order of WEEKDAYS so sunday is a first element
// we use weekdays to display day of week in consumption charts tooltip
// if we want to display short weekday then be aware that order should be changed here as well
export enum DAYS_SHORT {
  'GENERAL.MONDAY_SHORT', // Mon
  'GENERAL.TUESDAY_SHORT', // Tue
  'GENERAL.WEDNESDAY_SHORT', // Wed
  'GENERAL.THURSDAY_SHORT', // Thu
  'GENERAL.FRIDAY_SHORT', // Fri
  'GENERAL.SATURDAY_SHORT', // Sat
  'GENERAL.SUNDAY_SHORT', // Sun
}

export enum WEEKDAYS {
  '+SCHEDULES.DAY.SUNDAY',
  '+SCHEDULES.DAY.MONDAY',
  '+SCHEDULES.DAY.TUESDAY',
  '+SCHEDULES.DAY.WEDNESDAY',
  '+SCHEDULES.DAY.THURSDAY',
  '+SCHEDULES.DAY.FRIDAY',
  '+SCHEDULES.DAY.SATURDAY',
}

export enum CLOSE_MODAL_ACTIONS {
  OPEN_SRC_OVERLAY = 'OPEN_SRC_OVERLAY',
}

export enum HTMLExtractionPrefix {
  DASH = '-',
}

export enum DEVICE_SHORT_NAMES {
  Vitocal333G = 'Vitocal 333-G',
  Vitocal250A = 'Vitocal 250-A',
}

export enum constantWord {
  Total = 'total',
}

export enum Bool {
  True = 'true',
  False = 'false',
}
